// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"448e4de8","787":"33879777"}[chunkId] + ".chunk.js";
};